// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Phones (base) ── */
.page-toolbar {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-4);
}

.page-toolbar__filters,
.page-toolbar__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
  min-width: 0;
}

.page-toolbar__filters > * {
  flex: 1 1 100%;
  min-width: 0;
}

.page-toolbar__actions > * {
  flex: 1 1 0;
}

.page-toolbar__actions > .ant-btn,
.page-toolbar__actions > * > .ant-btn:only-of-type {
  width: 100%;
}

/* Search stays reachable while scrolling a long list. */
.page-toolbar--fab {
  position: sticky;
  top: 0;
  z-index: 20;
  margin-inline: calc(var(--ds-page-pad) * -1);
  margin-top: calc(var(--ds-page-pad) * -1);
  padding: var(--ds-page-pad) var(--ds-page-pad) var(--ds-space-3);
  background: linear-gradient(var(--ds-bg) 80%, rgba(244, 247, 249, 0));
}

/* The one primary action floats above the bottom bar (extended FAB). */
.page-toolbar--fab .page-toolbar__actions {
  display: contents;
}

.page-toolbar--fab .page-toolbar__actions .ant-btn-primary {
  position: fixed;
  z-index: 950;
  inset-inline-end: calc(var(--ds-space-4) + var(--ds-safe-right));
  bottom: calc(var(--ds-space-4) + var(--ds-safe-bottom));
  width: auto !important;
  height: 56px;
  padding-inline: 20px 22px;
  border-radius: 18px;
  font-size: 0.95rem;
  box-shadow:
    var(--ds-shadow-brand),
    0 2px 6px rgba(19, 33, 44, 0.12);
  animation: ds-fab-in 0.25s var(--ds-ease);
}

.page-toolbar--fab .page-toolbar__actions .ant-btn-primary svg {
  font-size: 16px;
}

.app-shell--with-bottomnav .page-toolbar--fab .page-toolbar__actions .ant-btn-primary {
  bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + var(--ds-space-4));
}

/* Leave room so the FAB never hides the last row. */
.app-content:has(.page-toolbar--fab) .app-content__inner {
  padding-bottom: 80px;
}

@keyframes ds-fab-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }
}

/* ── Tablet & desktop ── */
@media (min-width: 768px) {
  .page-toolbar {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: var(--ds-space-3);
    margin-bottom: var(--ds-space-5);
  }

  .page-toolbar__filters > * {
    flex: 0 1 320px;
  }

  .page-toolbar__actions {
    margin-inline-start: auto;
  }

  .page-toolbar__actions > * {
    flex: 0 0 auto;
  }

  .page-toolbar__actions > .ant-btn,
  .page-toolbar__actions > * > .ant-btn:only-of-type {
    width: auto;
  }
}

.page-toolbar--fab.page-toolbar--no-filters {
  position: static;
  margin: 0;
  padding: 0;
  background: none;
}
`, "",{"version":3,"sources":["webpack://./src/design-system/PageToolbar.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,4CAA4C;EAC5C,yCAAyC;EACzC,gEAAgE;EAChE,qEAAqE;AACvE;;AAEA,uEAAuE;AACvE;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gEAAgE;EAChE,uDAAuD;EACvD,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB;;oCAEkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+EAA+E;AACjF;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["/* ── Phones (base) ── */\n.page-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-4);\n}\n\n.page-toolbar__filters,\n.page-toolbar__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-width: 0;\n}\n\n.page-toolbar__filters > * {\n  flex: 1 1 100%;\n  min-width: 0;\n}\n\n.page-toolbar__actions > * {\n  flex: 1 1 0;\n}\n\n.page-toolbar__actions > .ant-btn,\n.page-toolbar__actions > * > .ant-btn:only-of-type {\n  width: 100%;\n}\n\n/* Search stays reachable while scrolling a long list. */\n.page-toolbar--fab {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  margin-inline: calc(var(--ds-page-pad) * -1);\n  margin-top: calc(var(--ds-page-pad) * -1);\n  padding: var(--ds-page-pad) var(--ds-page-pad) var(--ds-space-3);\n  background: linear-gradient(var(--ds-bg) 80%, rgba(244, 247, 249, 0));\n}\n\n/* The one primary action floats above the bottom bar (extended FAB). */\n.page-toolbar--fab .page-toolbar__actions {\n  display: contents;\n}\n\n.page-toolbar--fab .page-toolbar__actions .ant-btn-primary {\n  position: fixed;\n  z-index: 950;\n  inset-inline-end: calc(var(--ds-space-4) + var(--ds-safe-right));\n  bottom: calc(var(--ds-space-4) + var(--ds-safe-bottom));\n  width: auto !important;\n  height: 56px;\n  padding-inline: 20px 22px;\n  border-radius: 18px;\n  font-size: 0.95rem;\n  box-shadow:\n    var(--ds-shadow-brand),\n    0 2px 6px rgba(19, 33, 44, 0.12);\n  animation: ds-fab-in 0.25s var(--ds-ease);\n}\n\n.page-toolbar--fab .page-toolbar__actions .ant-btn-primary svg {\n  font-size: 16px;\n}\n\n.app-shell--with-bottomnav .page-toolbar--fab .page-toolbar__actions .ant-btn-primary {\n  bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + var(--ds-space-4));\n}\n\n/* Leave room so the FAB never hides the last row. */\n.app-content:has(.page-toolbar--fab) .app-content__inner {\n  padding-bottom: 80px;\n}\n\n@keyframes ds-fab-in {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.96);\n  }\n}\n\n/* ── Tablet & desktop ── */\n@media (min-width: 768px) {\n  .page-toolbar {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--ds-space-3);\n    margin-bottom: var(--ds-space-5);\n  }\n\n  .page-toolbar__filters > * {\n    flex: 0 1 320px;\n  }\n\n  .page-toolbar__actions {\n    margin-inline-start: auto;\n  }\n\n  .page-toolbar__actions > * {\n    flex: 0 0 auto;\n  }\n\n  .page-toolbar__actions > .ant-btn,\n  .page-toolbar__actions > * > .ant-btn:only-of-type {\n    width: auto;\n  }\n}\n\n.page-toolbar--fab.page-toolbar--no-filters {\n  position: static;\n  margin: 0;\n  padding: 0;\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
